import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../pages/sidebar.css";

export default function Hamburger({ children }) {
  const [open, setOpen] = useState(false);
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    setOpen(false);
  };

  return (
    <>
      <button
        className="btn btn-outline-primary hamburger"
        aria-label="Open sidebar"
        onClick={() => setOpen((prev) => !prev)}
      >
        <i className="bi bi-list fs-5"></i>
      </button>
      {open && (
        <>
          <div className="sidebar-overlay" onClick={() => setOpen(false)} />
          <div className="sidebar open">
            <nav className="nav-links">
              <Link to="/home" onClick={() => setOpen(false)}>Home</Link>
              <Link to="/list" onClick={() => setOpen(false)}>Task Lists</Link>
              <Link to="/admin" onClick={() => setOpen(false)}>
                <i className="bi bi-gear-fill me-2"></i>Admin
              </Link>
            </nav>
            
            {/* Logout Button */}
            <button 
              onClick={handleLogout}
              className="sidebar-logout-btn"
            >
              Logout
            </button>
            
            {/* User Information Section */}
            <div className="user-info-section">
              {user ? (
                <div className="user-info-content">
                  <div className="user-info-header">
                    <i className="bi bi-person-circle me-2"></i>
                    <span>Logged in as:</span>
                  </div>
                  <div className="user-info-username">
                    {user.username}
                  </div>
                </div>
              ) : (
                <div className="user-info-logged-out">
                  <i className="bi bi-person me-2"></i>
                  Not logged in
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}